/**
 * Operator Client
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ParkerClassification = {
    Unspecified: 'Unspecified',
    Employee: 'Employee',
    Student: 'Student',
    Visitor: 'Visitor',
    Contractor: 'Contractor',
    Other: 'Other',
    Apprentice: 'Apprentice',
    Supplier: 'Supplier'
} as const;
export type ParkerClassification = typeof ParkerClassification[keyof typeof ParkerClassification];

